import { toast } from "react-hot-toast";

export default function RedirectWithCountdown(
  navigate: (path: string) => void,
  path: string,
  seconds: number,
  baseMessage = "Redirecting"
) {
  let timeLeft = seconds;

  const toastId = toast.success(
    `${baseMessage} in ${timeLeft} seconds`,
    {
      duration: seconds * 1000,
      className: "custom-alert bg-white text-dark",
      position: "top-right",
    }
  );

  const interval = setInterval(() => {
    timeLeft--;

    if (timeLeft <= 0) {
      clearInterval(interval);
      toast.dismiss(toastId);
      navigate(path);
    } else {
      toast.success(
        `${baseMessage} in ${timeLeft} seconds`,
        { id: toastId }
      );
    }
  }, 1000);
}